<template>
  <div>
    <v-card style="border-radius: 0px !important" :elevation="noElevation ? 0 : 1" v-if="!($vuetify.breakpoint.xs || $vuetify.breakpoint.sm)">
      <v-row style="width: 100%; margin: 0" @click="navigate()">
        <!-- Profile Image -->
        <v-col cols="2" style="position: relative">
          <div style="position: absolute; top: 50%; left: 50%; -ms-transform: translate(-50%, -50%); transform: translate(-50%, -50%);">
            <v-avatar height="80px" width="80px" style="cursor: pointer">
              <v-img
                :src="page.profile_image"
                :lazy-src="lazyTransformation(page.profile_image)"
                alt="profile picture"
                aspect-ratio="1"
                v-if="page.profile_image"
              ></v-img>
              <v-icon size="110" color="primary" v-if="!page.profile_image" style="cursor: pointer">
                $account-circle
              </v-icon>
            </v-avatar>
          </div>
        </v-col>

        <!-- Info -->
        <v-col cols="5" style="flex: 100; max-width: 100%" @click="navigate()">
          <v-card-title style="padding-bottom: 0; padding-top: 0">
            <p style="margin: 0" class="title font-weight-medium">{{ page.title }} {{ page.first_name }} {{ page.last_name }}</p>
          </v-card-title>
          <div style="padding-left: 20px; padding-right: 40px; text-align: left">
            <v-container>
              <v-row>
                <p style="margin: 0">{{ page.residence !== ' ' ? 'aus ' + page.residence : '' }}</p>
                <v-spacer></v-spacer>
                <p style="margin: 0" v-if="page['birth_name']">geb. {{ page['birth_name'] }}</p>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <p style="margin: 0" v-if="page.birth">* {{ transformDate(page.birth) }}</p>
                <v-spacer></v-spacer>
                <p style="margin: 0"><v-icon size="18" style="margin-top: -5px" color="text">mdi-christianity</v-icon> {{ transformDate(page.obit) }}</p>
              </v-row>
            </v-container>
          </div>
        </v-col>

        <!-- Button -->
        <v-col cols="5" style="padding: 0 10%; margin: auto" @click="navigate()">
          <eternio-button style="min-height: 0 !important; height: 40px; border-radius: 50px; min-width: 200px" @click="navigate()">{{ page.type === 'ad' ? 'Anzeigen' : 'Zur Gedenkseite' }}</eternio-button>
        </v-col>
      </v-row>
    </v-card>

    <!-- Mobile -->
    <v-card style="border-radius: 0px !important" :elevation="noElevation ? 0 : 1" v-else  @click="navigate()">
      <v-row style="max-width: 100%; margin: 0">
        <!-- Profile Image -->
        <v-col cols="3">
          <div>
            <v-avatar height="50px" width="50px">
              <v-img
                :src="page.profile_image"
                :lazy-src="lazyTransformation(page.profile_image)"
                alt="profile picture"
                aspect-ratio="1"
                v-if="page.profile_image"
              ></v-img>
              <v-icon size="110" color="primary" v-if="!page.profile_image">
                $account-circle
              </v-icon>
            </v-avatar>
          </div>
        </v-col>

        <!-- Info -->
        <v-col cols="7" style="padding: 0; font-size: 14px">
          <div style="font-size: 16px">
            {{ page.title }} {{ page.first_name }} {{ page.last_name }}
          </div>
          <div style="padding: 0 5%">
            <v-row>
              {{ page.residence !== ' ' ? 'aus ' + page.residence : '' }}
              <v-spacer></v-spacer>
              <span v-if="page['birth_name']">geb. {{ page['birth_name'] }}</span>
            </v-row>

            <v-row>
              <span v-if="page.birth">* {{ transformDate(page.birth) }}</span>
              <v-spacer></v-spacer>
              <v-icon size="18" style="margin-top: -5px" color="text">mdi-christianity</v-icon> {{ transformDate(page.obit) }}
            </v-row>
          </div>
        </v-col>

        <!-- Button -->
        <v-col cols="2">
          <v-icon size="50px" class="primary--text">mdi-chevron-right</v-icon>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['page', 'noElevation'],
  methods: {
    transformDate (date) {
      var tmp = date.split('T')[0]
      tmp = tmp.split('-')
      return tmp[2] + '.' + tmp[1] + '.' + tmp[0]
    },
    lazyTransformation (str) {
      var strArray = str.split('.')
      strArray[strArray.length - 2] = strArray[strArray.length - 2] + '_lazy'
      return strArray.join('.')
    },
    navigate () {
      window.open('https://eternio.de/Gedenkseite/' + this.page.page_id,'_blank');
    }
  }
}
</script>

<style scoped>
  p {
    margin: 0 !important;
  }
</style>
